const palette = ['#0055CC', '#216E4E', '#803FA5', '#AE2E24', '#206A83', '#7F5F01', '#943D73', '#4F5B93'];
const accountColors = { nithinr: '#0055CC', winkc: '#216E4E', miken: '#803FA5', ericc: '#AE2E24', richb: '#206A83' };

const avatarName = (name) => String(name || '').trim().split(',')[0].trim().split('@')[0];

export const initials = (name) => {
  const value = avatarName(name);
  if (!value) return '?';
  const words = value.split(/\s+/);
  return (words.length > 1 ? words[0][0] + words[words.length - 1][0] : value[0] + (value.length > 1 ? value[value.length - 1] : '')).toUpperCase();
};

export const avatarStyle = (name) => {
  const value = avatarName(name).toLowerCase();
  if (!value) return undefined;
  const hash = Array.from(value).reduce((result, character) => (result * 31 + character.charCodeAt(0)) >>> 0, 0);
  const color = accountColors[value] || palette[hash % palette.length];
  return { backgroundColor: color, borderColor: color, color: '#fff' };
};

export const formatAssigneeName = (name) => String(name || '').split(',').map((entry) => {
  const value = entry.trim().split('@')[0];
  if (!value) return '';
  const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1);
  if (/\s/.test(value)) return value.split(/\s+/).map(capitalize).join(' ');
  if (value === value.toLowerCase() && /^[a-z]+$/.test(value) && value.length > 1) {
    return `${capitalize(value.slice(0, -1))} ${value.slice(-1).toUpperCase()}`;
  }
  return capitalize(value);
}).join(', ');
